export const FILE_STATUS = {
  ScannedClean: "ScannedClean",
  ScannedQuarantined: "ScannedQuarantined",
  PendingScan: "PendingScan",
  PendingUpload: "PendingUpload",
};
